import { render, staticRenderFns } from "./PonudaNovo.vue?vue&type=template&id=5a01631b"
import script from "./PonudaNovo.vue?vue&type=script&lang=js"
export * from "./PonudaNovo.vue?vue&type=script&lang=js"
import style0 from "./PonudaNovo.vue?vue&type=style&index=0&id=5a01631b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports